import BatchOutputLog from "./BatchOutputLog";
export default BatchOutputLog;
